// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_bC0","cls2":"AutoCompleteResults-cls2_2hS AutoCompleteResults-cls1_bC0"};